/**
 * EnumPlanCategory
 * @export EnumPlanCategory
 * @enum
 */


enum EnumPlanCategory {
  Preview = 'Preview',
  FreeTrial = 'FreeTrial',
  Sales = 'Sales',
  Paid = 'Paid',
}

export default EnumPlanCategory
